import React, { useState } from 'react';
import i18n from 'i18n-js';
import { Row, Card, CardGroup, CardBody, CardTitle } from 'reactstrap';
import { useAPIDataLoader } from '../../../hooks/api';
import { ZoneMap } from '../../../components/heatmap/ZoneMap';
import { ResponseLoading } from '../../../components/utils/Loading';
import StatsChart from '../../dashboard/StatsChart';
import { colors } from '../../../components/charts/Styles';
import LineChart from '../../../components/charts/LineChart';

export default function ViewContent({ responseRadar }) {
  const stores =
    responseRadar && responseRadar.hasValue('heatmap')
      ? responseRadar.data.value.heatmap.stores
      : [];

  const [storeSelected, setStoreSelected] = useState({});
  const [revenueData, setRevenueData] = useState([]);
  const [classData, setClassData] = useState([]);
  const [riskLevelData, setRiskLevelData] = useState([]);
  const [ownCarData, setOwnCarData] = useState([]);

  const responseFinancialData = useAPIDataLoader('premium.getFinancialData', storeSelected, {
    cache: true
  });
  if (responseFinancialData.error) {
    console.log('getFinancialData error', responseFinancialData.error);
  }

  const onSelectPOI = selected => {
    setStoreSelected(selected);
    if (responseFinancialData.hasValue('revenueData')) {
      setRevenueData(responseFinancialData.data.value.revenueData);
      setClassData(responseFinancialData.data.value.classData);
      setRiskLevelData(responseFinancialData.data.value.riskLevelData);
      setOwnCarData(responseFinancialData.data.value.ownCarData);
    }
  };

  return (
    <div className="view-content">
      <div style={{ position: 'relative', zIndex: 9999, right: 0, top: '-3.5vw' }}>
        <ResponseLoading
          responses={[responseRadar, responseFinancialData]}
          className="loading-dot-white"
        />
      </div>
      <Row>
        <div className="col-sm-5 col-md-5 pl-0">
          <Card className="mb-4 pr-0">
            <div style={{ width: '100%', height: '950px' }}>
              <ZoneMap pois={stores} onChange={onSelectPOI} zoom={8} />
            </div>
          </Card>
        </div>
        <div className="col-sm-7 col-md-7 p-0">
          <CardGroup
            className="metric-card mb-4"
            style={{ flexFlow: 'row wrap', minHeight: '950px' }}
          >
            <Card style={{ flex: '3 0 0' }}>
              <CardBody className="pb-0">
                <CardTitle className="text-uppercase h6">{i18n.t('metrics_title')}</CardTitle>
                <div className="small mb-4 card-subtitle">
                  {i18n.t('mobility_trends_by_zone')}:{' '}
                  <strong>{storeSelected.name ? storeSelected.name : '--'}</strong>
                </div>
                {storeSelected._id ? (
                  <>
                    <div className="col-sm-12 col-md-12 pr-0">
                      <Card className="mb-4">
                        <div style={{ width: '100%', height: '250px' }}>
                          <LineChart
                            data={revenueData}
                            dataKeyX="date"
                            dataKeyY="revenue"
                            stroke={colors[0]}
                            format="$ 0.[00]a"
                            marginTop={20}
                            marginRight={40}
                          />
                        </div>
                      </Card>
                    </div>
                    <div className="col-sm-12 col-md-12 pr-0">
                      <Card className="mb-4">
                        <Row>
                          <div className="col-sm-6 col-md-6 pr-0">
                            <div style={{ width: '100%', height: '283px' }} className="p-3">
                              <h6>{i18n.t('premium_financial_economic_level')}</h6>
                              <StatsChart response={classData} dataKey="perc" legend={false} />
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6">
                            <div style={{ width: '100%', height: '283px' }} className="p-3">
                              <h6>{i18n.t('premium_financial_credit_risk')}</h6>
                              <StatsChart response={riskLevelData} dataKey="perc" legend={false} />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-12">
                            <div style={{ width: '100%', height: '283px' }} className="p-3">
                              <h6>{i18n.t('premium_financial_own_car')}</h6>
                              <StatsChart response={ownCarData} dataKey="perc" legend={false} />
                            </div>
                          </div>
                        </Row>
                      </Card>
                    </div>
                  </>
                ) : null}
              </CardBody>
            </Card>
          </CardGroup>
        </div>
      </Row>
    </div>
  );
}
